
import { BasicModel } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { TextFieldAutoSize } from "@goodgamestudios/createjs-utilities";
import { SFConstants } from "../../../constants/SFConstants";
import { Poker2SoundController } from "../../../controller/Poker2SoundController";
import { Poker2Model } from "../../../model/Poker2Model";
import { TurnTimerComponent } from "../../components/playerContainer/TurnTimerComponent";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2TournamentRebuyDialogProperties } from "./Poker2TournamentRebuyDialogProperties";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2TournamentRebuyDialog extends Poker2Dialog {
    public static NAME: string = "Poker2TournamentRebuyDialog";

    private buyIn: number = NaN;
    private turnTimer: TurnTimerComponent;

    /** Timeout duration for the rebuy in seconds. **/
    private REBUY_DURATION: number = 20;
    private _canceled: boolean = false;
    private _accepted: boolean = false;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    private handleTurnTimerEvent(progress: number): void {
        if (this._canceled || this._accepted) {
            return;
        }

        switch (progress) {
            case 0.5:
                this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_TIME);
                break;

            case 1:
                this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_LATE);
                this.stopRebuyTimer();
                this.cancelRebuy();
                this.hide();
                break;
        }
    }

    private stopRebuyTimer(): void {
        if (this.turnTimer) {
            this.turnTimer.stopAll();
            this.turnTimer = null;
        }
    }

    protected applyProperties(): void {
        // button labels
        this.tournamentRebuyView.btn_cancle.label = Poker2Model.languageData.getTextById("generic_btn_goback");
        this.tournamentRebuyView.btn_ok.label = Poker2Model.languageData.getTextById("generic_btn_okay");

        // check if user has enough cash for the rebuy
        if (Poker2Model.userData.userCash > this.tournamentRebuyDialogProperties.chips) {
            /** User have enough cash, show the fee. **/
            // headline
            TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.tournamentRebuyView.txt_title, Poker2Model.languageData.getTextById("take_seat_title_chipsOut"));

            // copy texts
            this.tournamentRebuyView.txt_copy.text = Poker2Model.languageData.getTextById("take_seat_copy_chipsOut");
            this.tournamentRebuyView.txt_copy.autoSize = TextFieldAutoSize.LEFT;
            this.tournamentRebuyView.txt_copy2.text = Poker2Model.languageData.getTextById("take_seat_copy2_chipsOut", [this.tournamentRebuyDialogProperties.tournamentName]);
            this.tournamentRebuyView.txt_copy2.autoSize = TextFieldAutoSize.LEFT;
            this.tournamentRebuyView.txt_copy2.y = this.tournamentRebuyView.txt_copy.y + this.tournamentRebuyView.txt_copy.textHeight + 15;

            // button visibility
            this.tournamentRebuyView.btn_ok.enableButton = true;
            this.tournamentRebuyView.btn_moreGold.visible = false;

            // fee texts
            this.tournamentRebuyView.mc_fee.visible = true;
            this.displayBuyinFee();
        }
        else {
            /** User don't have enough cash, show button for buyin chips/gold. **/
            // headline
            TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.tournamentRebuyView.txt_title, Poker2Model.languageData.getTextById("take_seat_title_chipsOut"));

            // copy texts
            this.tournamentRebuyView.txt_copy.text = Poker2Model.languageData.getTextById("take_seat_copy_noBuyin");
            this.tournamentRebuyView.txt_copy.autoSize = TextFieldAutoSize.LEFT;

            // button visibility
            this.tournamentRebuyView.btn_ok.enableButton = false;
            this.tournamentRebuyView.btn_moreGold.label = Poker2Model.languageData.getTextById("dialog_nomoney_btn_moregold");
            this.tournamentRebuyView.btn_moreGold.visible = true;
            this.tournamentRebuyView.btn_moreGold.y = this.tournamentRebuyView.txt_copy.y + this.tournamentRebuyView.txt_copy.textHeight + 40;

            // hide fee texts
            this.tournamentRebuyView.mc_fee.visible = false;
        }

        // create register timer
        if (!this.turnTimer) {
            this.turnTimer = new TurnTimerComponent();
            this.turnTimer.onTurnTimerCallbackTrigger = this.bindFunction(this.handleTurnTimerEvent);
            this.tournamentRebuyView.mc_clockHolder.addChild(this.turnTimer);
            this.turnTimer.startTimer(this.REBUY_DURATION);
        }

        this._accepted = false;
        this._canceled = false;
    }

    private displayBuyinFee(): void {
        // chips
        if (!isNaN(this.tournamentRebuyDialogProperties.chips) && this.tournamentRebuyDialogProperties.chips > 0) {
            this.tournamentRebuyView.mc_fee.txt_chips_value.text = NumberStringHelper.groupString(this.tournamentRebuyDialogProperties.chips, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
            this.tournamentRebuyView.mc_fee.txt_chips_value.autoSize = TextFieldAutoSize.LEFT;
            this.tournamentRebuyView.mc_fee.txt_chips_value.visible = true;
            this.tournamentRebuyView.mc_fee.icon_chips.visible = true;
        }
        else {
            this.tournamentRebuyView.mc_fee.txt_chips_value.visible = false;
            this.tournamentRebuyView.mc_fee.icon_chips.visible = false;
        }

        // gold
        if (!isNaN(this.tournamentRebuyDialogProperties.gold) && this.tournamentRebuyDialogProperties.gold > 0) {
            this.tournamentRebuyView.mc_fee.txt_gold_value.text = NumberStringHelper.groupString(this.tournamentRebuyDialogProperties.gold, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
            this.tournamentRebuyView.mc_fee.txt_gold_value.autoSize = TextFieldAutoSize.LEFT;
            this.tournamentRebuyView.mc_fee.txt_gold_value.visible = true;
            this.tournamentRebuyView.mc_fee.icon_gold.visible = true;
        }
        else {
            this.tournamentRebuyView.mc_fee.txt_gold_value.visible = false;
            this.tournamentRebuyView.mc_fee.icon_gold.visible = false;
        }

        // center fee
        this.tournamentRebuyView.mc_fee.x = -(this.tournamentRebuyView.mc_fee.txt_chips_value.x + this.tournamentRebuyView.mc_fee.txt_chips_value.textWidth) * .5;
        this.tournamentRebuyView.mc_fee.y = this.tournamentRebuyView.txt_copy2.y + this.tournamentRebuyView.txt_copy2.textHeight + 20;
    }

    public show(): void {
        super.show();
    }

    public destroy(): void {
        super.destroy();
        this.stopRebuyTimer();
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.target) {
            case this.tournamentRebuyView.btn_cancle:

                this.hide();
                this.stopRebuyTimer();
                this.cancelRebuy();
                break;
            case this.tournamentRebuyView.btn_ok:

                this.hide();
                this.stopRebuyTimer();
                this.acceptRebuy();
                break;
            case this.tournamentRebuyView.btn_moreGold:
                if (Poker2Model.userData.isGuest()) {
                    this.controller.onStartRegisterDialog();
                }
                else {
                    this.controller.onClickMoreMoney(null);
                }
                this.hide();
                break;
        }
    }

    private acceptRebuy(): void {
        this._accepted = true;
        BasicModel.smartfoxClient.sendMessage("jrb", [JSON.stringify({ tid: this.tournamentRebuyDialogProperties.tournamentId, rebuy: true })]);
    }

    private cancelRebuy(): void {
        this._canceled = true;
        BasicModel.smartfoxClient.sendMessage("jrb", [JSON.stringify({ tid: this.tournamentRebuyDialogProperties.tournamentId, rebuy: false })]);
    }

    protected get tournamentRebuyDialogProperties(): Poker2TournamentRebuyDialogProperties {
        return this.properties as Poker2TournamentRebuyDialogProperties;
    }

    protected get tournamentRebuyView(): Library.PokerInterface.PokerTournamentRebuy {
        return this.disp as Library.PokerInterface.PokerTournamentRebuy;
    }
}
